export const LoadingPageStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  width: '100%',
  minHeight: '100vh',
  m: 2
};
